import { ProductModificationProcessService } from "@/api/services";
import { ProductModificationProcess } from "@/api/models/customer";
import { PRODUCT_MODIFICATION_PROCESS_CLEAR_ACTION, PRODUCT_MODIFICATION_PROCESS_CLEAR_STATE } from "./constants";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";

const clear = ({ commit }: any) => {
	commit(PRODUCT_MODIFICATION_PROCESS_CLEAR_STATE);

	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const createProductModificationProcess = ({ commit }: any, productModificationProcess: ProductModificationProcess) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.create({ productModificationProcess })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getProductModificationById = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.getById(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateProductModification = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.update(payload.id, payload.data)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const sendProductModification = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.send(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductModification = ({ commit }: any, productModification: any) => {
	commit("setProductModification", productModification);
};

const saveProductModificationShoppingCartId = ({ commit }: any, shoppingCartId: string) => {
	commit("setProductModificationShoppingCartId", shoppingCartId);
};

const saveProductModificationStatus = ({ commit }: any, status: string) => {
	commit("setProductModificationStatus", status);
};

const getProductModificationConfiguration = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.getModificationProcessConfiguration({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateModificationProcessConfiguration = (
	{ commit }: any,
	payload: { productId: string; shoppingCartId: string; bundles: any[]; parameters: any[] }
) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.putModificationProcessConfiguration(payload)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getModificationProcessSummary = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.getModificationProcessSummary({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const deleteProductModification = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductModificationProcessService.delete(payload.id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	[PRODUCT_MODIFICATION_PROCESS_CLEAR_ACTION]: clear,
	createProductModificationProcess,
	getProductModificationById,
	updateProductModification,
	sendProductModification,
	saveProductModification,
	saveProductModificationShoppingCartId,
	saveProductModificationStatus,
	getProductModificationConfiguration,
	updateModificationProcessConfiguration,
	getModificationProcessSummary,
	deleteProductModification
};
